import React, { useState, useRef, useCallback, useEffect } from 'react'
import Classes from './Upgrades.module.css'
import Color from 'color';
import { useSelector } from 'react-redux';
import backend from '../../../../../api';
import { motion, easeOut, AnimatePresence } from 'framer-motion';

const CheckSvg = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
)

export default function Upgrades() {

    const onBoarding = useSelector((state) => state.companyInfo?.info);
    const companyId = onBoarding?._id;
    const { user } = useSelector((state) => state.auth);
    const [isYearly, setisYearly] = useState(true);

    const email = user?.email;
    const convertToRgba = (colorInput, opacity) => {
        try {
            const color = Color(colorInput);
            return color.alpha(opacity).rgb().string();
        } catch (error) {
            console.error("Invalid color format:", colorInput);
            return `rgba(0, 0, 0, ${opacity})`;
        }
    };

    const onPaymentMonthlyBasic = async () => {

        const total_users = onBoarding?.total_users
        const remaining_users = 100;
        const companyName = onBoarding?.companyName
        const allowed_admins = 10;

        // const response = await backend.put(`/api/user/${user._id}`, body);
        const response = await backend.post(`/create-checkout-session`, {
            subscription: "monthly_basic",
            total_users: total_users,
            remaining_users: remaining_users,
            companyId: companyId,
            companyName: companyName,
            allowed_admins: allowed_admins,
            email: email
        })

        const url = response.data.url;
        window.location.href = url;
    }

    const onPaymentMonthlyEnterprise = async () => {

        const total_users = onBoarding?.total_users
        const remaining_users = 100000;
        const companyName = onBoarding?.companyName
        const allowed_admins = 100000;

        // const response = await backend.put(`/api/user/${user._id}`, body);
        const response = await backend.post(`/create-checkout-session`, {
            subscription: "monthly_pro",
            total_users: total_users,
            remaining_users: remaining_users,
            companyId: companyId,
            companyName: companyName,
            allowed_admins: allowed_admins,
            email: email
        })

        const url = response.data.url;
        window.location.href = url;
    }

    const onPaymentYearlyBasic = async () => {

        const total_users = onBoarding?.total_users
        const remaining_users = 1200;
        const companyName = onBoarding?.companyName
        const allowed_admins = 10;

        // const response = await backend.put(`/api/user/${user._id}`, body);
        const response = await backend.post(`/create-checkout-session`, {
            subscription: "yearly_basic",
            total_users: total_users,
            remaining_users: remaining_users,
            companyId: companyId,
            companyName: companyName,
            allowed_admins: allowed_admins,
            email: email

        })

        const url = response.data.url;
        window.location.href = url;
    }

    const onPaymentYearlyEnterprise = async () => {

        const total_users = onBoarding?.total_users
        const remaining_users = 100000;
        const companyName = onBoarding?.companyName
        const allowed_admins = 100000;

        // const response = await backend.put(`/api/user/${user._id}`, body);
        const response = await backend.post(`/create-checkout-session`, {
            subscription: "yearly_pro",
            total_users: total_users,
            remaining_users: remaining_users,
            companyId: companyId,
            companyName: companyName,
            allowed_admins: allowed_admins,
            email: email

        })

        const url = response.data.url;
        window.location.href = url;
    }

    return (
        <>
            <div className={Classes.hero} >
                <div className={Classes.flexButtons} >
                    <div className={Classes.pricingBtns} >
                        <button onClick={() => setisYearly(false)} className={Classes.toggleButton} style={{ background: isYearly ? 'transparent' : onBoarding?.color, color: isYearly ? 'black' : 'white' }} >
                            <h5>Monthly</h5>
                        </button>
                        <button onClick={() => setisYearly(true)} className={Classes.toggleButton} style={{ background: isYearly ? onBoarding?.color : 'transparent', color: isYearly ? 'white' : 'black' }} >
                            <h5>Yearly</h5>
                        </button>
                    </div>
                    <h5 className={Classes.saveText} >Save 15% by billing annually</h5>
                </div>
                <div className={Classes.pricingMain} >
                    <motion.div
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 10 }}
                        transition={{
                            delay: 0.3,
                            duration: 0.3,
                        }}
                    >
                        <div className={`${Classes.pricingElem} ${Classes.padding3}`} style={{ border: 'none' }} >
                            <div className={Classes.header} >

                            </div>
                            <div className={Classes.listingCon} >
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Team Seats </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Invite admins and other team members
                                                to collaborate and track submitted
                                                companies.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > White-Labeled Dashboard </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                The amount of companies that can
                                                register on your landing page
                                                and submit their pitch decks.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Unique Landing Page </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Your unique land page link that you
                                                send out to applicants for them to
                                                register and submit decks.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Custom Onboarding </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Screening tool customized for your
                                                ecosystem with a custom logo
                                                and color scheme.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Workflow Building </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Select from 7 different AI scoring
                                                criteria to analyze and score
                                                submitted pitch decks.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Client Management </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Submitted pitch decks are thoroughly
                                                analyzed based on the custom AI
                                                scoring criteria you choose.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Analytics </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Invite admins or scorers to add
                                                personalized human scores and
                                                comments to company submissions.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > Reporting </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Pipeline enables ecosystems to
                                                defer, request information, review
                                                material, and approve companies.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                                <div className={Classes.flexEnd}>
                                    <h5 className={Classes.textBold} > API Integrations </h5>
                                    {/* <div className={Classes.tooltipCon} >
                                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                                        <div className={Classes.tooltipBody}>
                                            <h5>
                                                Pipeline enables ecosystems to
                                                defer, request information, review
                                                material, and approve companies.
                                            </h5>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{
                            duration: 0.4,
                        }}
                    >
                        <div className={Classes.pricingElem} >
                            <div className={Classes.header} >
                                <div className={Classes.header} >
                                    <h5 className={Classes.title1} > Basic </h5>
                                    <h1 className={Classes.price} > {isYearly ? '$25' : '$29.99'} <span>/month</span> </h1>
                                    <h5 className={Classes.textLightMini} > Billed {isYearly ? 'annually' : 'monthly'} </h5>
                                </div>
                            </div>
                            <div className={Classes.listingCon} >
                                <div className={Classes.flex}> <h5 className={Classes.text} > 2 </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Basic </h5> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Basic </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Basic </h5> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Basic </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                            </div>
                            <div className='flex' >
                                <div className={Classes.btnCon} >
                                    {onBoarding?.subscription === 'free' ?
                                        <h5 className={`${Classes.textLight} ${Classes.btnHeight} flex`} > Your current plan </h5>
                                        :
                                        <button className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                        > <h5>Go free</h5> </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{
                            delay: 0.1,
                            duration: 0.5,
                        }}
                    >
                        <div className={Classes.pricingElem} style={{ background: convertToRgba(onBoarding?.color, 0.10) }} >
                            <div className={Classes.header} >
                                <h5 className={Classes.title1} > Pro </h5>
                                <h1 className={Classes.price} > {isYearly ? '$50' : '$59.99'} <span>/month</span> </h1>
                                <h5 className={Classes.textLightMini} > Billed {isYearly ? 'annually' : 'monthly'} </h5>
                            </div>
                            <div className={Classes.listingCon} >
                                <div className={Classes.flex}> <h5 className={Classes.text} > 7 </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Advanced </h5> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Advanced </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Advanced </h5> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Advanced </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                            </div>
                            {isYearly ?
                                <div className='flex' >
                                    <div className={Classes.btnCon} >
                                        {onBoarding?.subscription === 'yearly_basic' ?
                                            <h5 className={`${Classes.textLight} ${Classes.btnHeight} flex`} > Your current plan </h5>
                                            :
                                            <button className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                                onClick={onPaymentYearlyBasic}
                                            > <h5>Go yearly</h5> </button>
                                        }
                                    </div>
                                </div>
                                :
                                <div className='flex' >
                                    <div className={Classes.btnCon} >
                                        {onBoarding?.subscription === 'monthly_basic' ?
                                            <h5 className={`${Classes.textLight} ${Classes.btnHeight} flex`} > Your current plan </h5>
                                            :
                                            <button className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                                onClick={onPaymentMonthlyBasic}
                                            > <h5>Go monthly</h5> </button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{
                            delay: 0.2,
                            duration: 0.6,
                        }}
                    >
                        <div className={Classes.pricingElem} >
                            <div className={Classes.header} >
                                <h5 className={Classes.title1} > Enterprise </h5>
                                <h1 className={Classes.price} > {isYearly ? '$100' : '$114.99'} <span>/month</span> </h1>
                                <h5 className={Classes.textLightMini} > Billed {isYearly ? 'annually' : 'monthly'} </h5>
                            </div>
                            <div className={Classes.listingCon} >
                                <div className={Classes.flex}> <h5 className={Classes.text} > Unlimited </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Premium </h5> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Premium </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Premium </h5> </div>
                                <div className={Classes.flex}> <h5 className={Classes.text} > Premium </h5> </div>
                                <div className={Classes.flex}> <CheckSvg height={18} fill={onBoarding?.color} /> </div>
                            </div>
                            {isYearly ?
                                <div className='flex' >
                                    <div className={Classes.btnCon} >
                                        {onBoarding?.subscription === 'yearly_pro' ?
                                            <h5 className={`${Classes.textLight} ${Classes.btnHeight} flex`} > Your current plan </h5>
                                            :
                                            <button className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                                onClick={onPaymentYearlyEnterprise}
                                            > <h5>Go yearly</h5> </button>
                                        }
                                    </div>
                                </div>
                                :
                                <div className='flex' >
                                    <div className={Classes.btnCon} >
                                        {onBoarding?.subscription === 'monthly_pro' ?
                                            <h5 className={`${Classes.textLight} ${Classes.btnHeight} flex`} > Your current plan </h5>
                                            :
                                            <button className={Classes.btnHeight} style={{ background: onBoarding?.color }}
                                                onClick={onPaymentMonthlyEnterprise}
                                            > <h5>Go monthly</h5> </button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </motion.div>
                </div>
            </div>
        </>
    )
}
